import { CheckCircle2, Clock, MoveRight, XCircle } from "lucide-react";

// Pastel-tinted group palette (no red: it reads as "cancelled/error").
const PALETTE = [
    "#9333EA", "#3B82F6", "#10B981", "#F59E0B", "#EC4899", "#06B6D4",
    "#6366F1", "#14B8A6", "#F97316", "#84CC16", "#A855F7", "#0EA5E9",
];

const hash = (s: string) => { let h = 2166136261; for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; };
const rgba = (hex: string, a: number) => `rgba(${parseInt(hex.slice(1, 3), 16)}, ${parseInt(hex.slice(3, 5), 16)}, ${parseInt(hex.slice(5, 7), 16)}, ${a})`;

// `index` (position among the tenant's groups) guarantees distinct colours; the hash is a fallback.
export function groupColor(key: string, index?: number) {
    const dot = PALETTE[(index !== undefined && index >= 0 ? index : hash(key)) % PALETTE.length];
    return { dot, bg: rgba(dot, 0.12), border: rgba(dot, 0.35) };
}

export const STATUS_ICON = {
    scheduled: { Icon: Clock, color: "var(--text-muted)" },
    held: { Icon: CheckCircle2, color: "var(--success-fg)" },
    cancelled: { Icon: XCircle, color: "var(--error-fg)" },
    moved: { Icon: MoveRight, color: "var(--warning-fg)" },
};
